import React, { useState } from 'react'
import { connect } from 'react-redux'
import MenuIcon from '@material-ui/icons/Menu'
import CloseIcon from '@material-ui/icons/Close'
import { Link as RouterLink } from 'react-router-dom'

import {
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListSubheader,
  ListItemText,
  ListItemIcon,
  Link,
} from '@material-ui/core'
import makeStyles from '@material-ui/core/styles/makeStyles'

import data from '../../data/appData'
import { clearFriendsAtDateTime } from '../../redux/modules/friends'
import { isSelectedDeliveryDateActive, selectIsAuthenticated } from '../../redux/modules/selectors'
import { ROLE_FOODSBY_ADMIN } from '../../redux/modules/user'

import { ProfileAvatar } from '../profile/ProfilePicture'
import NavImpersonation from './NavImpersonation'

const FOODSBY_ONE_AUTHORITIES = ['ROLE_ACCOUNTS_READ', 'ROLE_FOODSBY_ACCOUNTS_READ']
const isAdmin = (authorities = []) => authorities.includes(ROLE_FOODSBY_ADMIN)
const isFoodsbyOne = authorities =>
  authorities && authorities.some(auth => FOODSBY_ONE_AUTHORITIES.includes(auth))

const ProfileImage = ({ avatarId, isWebpSupported, name }) => {
  const imgSrc =
    avatarId &&
    `${process.env.REACT_APP_IMAGE_LAMBDA}/profiles/${avatarId}.${
      isWebpSupported ? 'webp' : 'jpg'
    }?height=50&width=50`

  return <ProfileAvatar name={name} size="xsmall" src={imgSrc} />
}

const useStyles = makeStyles(theme => ({
  offset: theme.mixins.toolbar,
  drawer: {
    width: 240,
  },
  drawerRoot: {
    zIndex: '999999 !important',
  },
  iconRoot: {
    minWidth: 45,
    width: 45,
  },
}))

const Header = ({ avatarId, currentUser, isAuthenticated, isWebpSupported, profileStatus }) => {
  const [showDrawer, setShowDrawer] = useState(false)

  const classes = useStyles()

  // Let's clean this up, we could pass profile as prop and solve the admin
  let flyoutLinks =
    profileStatus !== 'CONFIRMED'
      ? [...data.simpleMenu]
      : [
          {
            ...data.headerMenu[0],
            icon: (
              <>
                <ProfileImage avatarId={avatarId} isWebpSupported={isWebpSupported} />
              </>
            ),
          },
          ...data.headerMenu.slice(1),
        ]
  if (isAuthenticated) {
    if (isAdmin(currentUser.authorities)) {
      flyoutLinks = [...flyoutLinks, ...data.adminMenu]
    }
    if (isFoodsbyOne(currentUser.authorities)) {
      flyoutLinks = [...flyoutLinks, ...data.foodsbyOne]
    }
    flyoutLinks = [...flyoutLinks, ...data.logout]
  }

  const isImpostor =
    isAuthenticated && (currentUser?.authorities?.includes('ROLE_IMPOSTOR') ?? false)

  return (
    <>
      <AppBar position="fixed" color="inherit">
        <Toolbar>
          <Link component={RouterLink} to={'/'}>
            <img
              alt="Foodsby Logo"
              component="img"
              src={`${process.env.REACT_APP_BASE_ORDER_URL}/images/logo-foodsby.png`}
              title="Foodsby Logo"
              style={{ maxHeight: 36 }}
            />
          </Link>
          <div style={{ flexGrow: 1 }} />
          <div>
            <IconButton onClick={() => setShowDrawer(true)}>
              <MenuIcon />
            </IconButton>
          </div>
        </Toolbar>
        {isImpostor && <NavImpersonation />}
      </AppBar>
      <Drawer
        anchor="right"
        open={showDrawer}
        onClose={() => setShowDrawer(false)}
        classes={{ paper: classes.drawer, root: classes.drawerRoot }}
      >
        <List>
          <ListSubheader className={classes.listHeader}>
            <IconButton style={{ float: 'right' }} onClick={() => setShowDrawer(false)}>
              <CloseIcon />
            </IconButton>
          </ListSubheader>
          {flyoutLinks.map((li, i) => (
            <ListItem key={i} button component="a" href={li.href}>
              {li.icon && (
                <ListItemIcon classes={{ root: classes.iconRoot }}>{li.icon}</ListItemIcon>
              )}

              <ListItemText>{li.copy}</ListItemText>
            </ListItem>
          ))}
        </List>
      </Drawer>
      <div className={classes.offset} />
      {/* we need another one of these if impersonating */}
      {isImpostor && <div className={classes.offset} />}
    </>
  )
}

function mapStateToProps(state) {
  const { location: { activationDate } = {} } = state.location
  const isSelectedDayActive = isSelectedDeliveryDateActive(state)
  const isAuthenticated = selectIsAuthenticated(state)
  const { selectedDate, todaysDate } = state.home
  const { friendsAtOrderDelivered } = state.friends
  const { isWebpSupported } = state.browser
  return {
    activationDate,
    friendsAtOrderDelivered,
    isAuthenticated,
    isSelectedDayActive,
    isWebpSupported,
    selectedDate,
    todaysDate,
  }
}

const mapDispatchToProps = {
  clearFriendsAtDateTime,
}

Header.defaultProps = {
  menuItems: [],
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)
